import { Clock, MapPin, UserRound } from "lucide-react";
import { BRAND } from "@/data/content";
import { isOpenNow } from "@/lib/ui";
import { FadeUp } from "@/components/Reveal";

const CELLS = [
  { icon: UserRound, label: "Owner", value: BRAND.owner, sub: "At the counter every day", id: "owner" },
  { icon: Clock, label: "Timings", value: BRAND.hours, sub: "Open every single day", id: "hours" },
  { icon: MapPin, label: "Location", value: "Opposite N.M.H.S. School", sub: "Banskandi", id: "location" },
];

export default function InfoBar() {
  const openNow = isOpenNow();
  return (
    <section data-testid="info-bar" className="bg-cream text-ink">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-10 md:py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6">
        {CELLS.map((c, i) => (
          <FadeUp key={c.id} delay={i * 0.08} className="flex items-start gap-4">
            <div className="w-11 h-11 shrink-0 rounded-full border border-gold-dark/40 flex items-center justify-center text-gold-dark">
              <c.icon className="w-5 h-5" />
            </div>
            <div>
              <p className="text-[10px] uppercase tracking-[0.28em] text-ink/50">{c.label}</p>
              <p className="mt-1 font-display font-semibold text-lg leading-snug">{c.value}</p>
              <p className="mt-0.5 text-sm text-ink/55">{c.sub}</p>
            </div>
          </FadeUp>
        ))}
        <FadeUp delay={0.24} className="flex items-start gap-4">
          <div className="w-11 h-11 shrink-0 rounded-full border border-gold-dark/40 flex items-center justify-center text-gold-dark">
            <span className={`w-2.5 h-2.5 rounded-full ${openNow ? "bg-emerald-500" : "bg-saffron"} animate-pulse`} />
          </div>
          <div>
            <p className="text-[10px] uppercase tracking-[0.28em] text-ink/50">Right now</p>
            <p data-testid="infobar-status" className="mt-1 font-display font-semibold text-lg">
              {openNow ? "We're open" : "Opens at 5 AM"}
            </p>
            <p className="mt-0.5 text-sm text-ink/55">Walk in or call ahead</p>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
